import React, { useState } from 'react';
import { styled, Box, Tab, Tabs } from '@mui/material';
import PageHeader from '../../../components/PageHeader';
import { TabContext, TabPanel } from '@mui/lab';

import SystemSchedule from './SystemSchedule';
import ClearLog from './ClearLog';

const SystemManagement: React.FC = () => {
  const [controlType, setControlType] = useState<'system_schedule' | 'clear_log'>(
    'system_schedule'
  );
  return (
    <RootContainer>
      <PageHeader text="เมนูระบบการจัดการ" />
      <TabContext value={controlType}>
        <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={controlType}
            onChange={(_, value) => setControlType(value)}
            aria-label="basic tabs example"
          >
            <Tab label="การจัดการข้อมูล" value={'system_schedule'} />
            <Tab label="การลบข้อมูลย้อนหลัง" value={'clear_log'} />
          </Tabs>
        </Box>
        <TabPanel value="system_schedule" sx={{ px: 0 }}>
          <SystemSchedule />
        </TabPanel>
        <TabPanel value="clear_log" sx={{ px: 0 }}>
          <ClearLog />
        </TabPanel>
      </TabContext>
    </RootContainer>
  );
};

export default SystemManagement;

const RootContainer = styled('div')`
  padding: 24px;
`;

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
